/**
 * @author Ariel
 * @desc 活动环节表单页面
 * @date 2020-09-21
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from '../../../../../tool'

import moment from "moment";
import createColumns from './columns'

let { WizContainer, modelUtils, WizAvatarUpload, ossFileUtils, } = framework_tool
let { WizCard, WizSpin, WizForm, Wizmessage, WizRow, WizCol, WizAutoComplete, WizInput } = component_tool
let { Session } = utils_tool

class ActivityPartDetail extends WizContainer {
  componentName = 'activityPartDetail'

  constructor(props) {
    super(props)
    const { history } = props
    let initialValue = {}
    let cardTitle = '新增'
    if (history.location) {
      if (history.location && history.location.record) {
        initialValue = history.location.record
        Session.set('initialValue', initialValue)
      } else {
        initialValue = Session.get('initialValue') || {}
      }
      if (history.location.pathname === '/interact/activity/activityDetailToPart/activityPartDetailUpd') {
        cardTitle = '编辑'
      }
    }
    this.initialValue = initialValue
    this.state = {
      cardTitle,
      columns: createColumns(this, this.initialValue),
      selectValue: '',
      time: new Date().getTime(),
      changeImg: []
    }
  }

  _componentDidMount() {
    if (this.initialValue && this.initialValue.id) {
      this.doAction({
        path: 'activityPart/look',
        payload: {
          key: 'activityPartInfo',
          apiParams: { id: this.initialValue.id }
        }
      })
    }
  }

  propsAndStateOnChange = {
    addActivityPart: this._addActivityPartOver.bind(this),
    activityPartInfo: this._activityPartInfoOver.bind(this),
    selectValue: this._selectValue.bind(this)
  }

  _selectValue(nextProps, nextState) {
    let { selectValue } = nextState
    this.wizFormRef && this.wizFormRef.setFieldsValue({ title: selectValue })
    return true
  }

  _addActivityPartOver(nextProps, nextState) {
    if (nextProps.addActivityPart.code == 1) {
      wizNotice.success('保存成功');
      let { activityId } = this.initialValue
      this.jumpPage('replace', '/interact/activity/activityDetailToPart', { activityId: activityId });
    } else {
      wizNotice.error('提交失败：' + nextProps.addActivityPart.msg);
    }
    return true;
  }


  _activityPartInfoOver(nextProps, nextState) {
    let { activityPartInfo } = nextProps
    if (activityPartInfo.code == 1) {
      if (activityPartInfo && activityPartInfo.success) {
        this.initialValue = activityPartInfo.data
        nextState['changeImg'] = activityPartInfo.data['fileIds'] || []
      }
      nextState['selectValue'] = this.initialValue['title']
      nextState['columns'] = createColumns(this, this.initialValue)
      nextState['time'] = new Date().getTime()
    } else {
      wizNotice.error(nextProps.activityPartInfo.msg || '数据获取失败，请稍后再试');
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'activityPartTime' && value != null && value != undefined) {
        fitterValues['startTime'] = moment(value[0]).format("YYYY-MM-DD HH:mm:00")
        fitterValues['endTime'] = moment(value[1]).format("YYYY-MM-DD HH:mm:59")
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    /**
     * 图片参数处理
     */
    let cover = fitterValues['cover']
    if (cover && cover.length) {
      fitterValues['coverImg'] = cover[0]['fileId']
      delete fitterValues['cover']
    }
    return fitterValues;
  }

  _addActivityPart(values) {
    let { fileList } = values
    let files = []
    fileList && fileList.length && fileList.forEach(img => {
      files.push(img.fileId)
    })
    if (fileList && fileList.length && fileList.length > 9) {
      wizNotice.error('最多上传9张图片')
      return false;
    } else {
      values['fileList'] = files
      const { history } = this.props
      let apiPath = 'activityPart/add';
      if (history.location && history.location.pathname === '/interact/activity/activityDetailToPart/activityPartDetailUpd') {
        apiPath = 'activityPart/update'
      }
      let fitterValues = this.fitterFieldsValue(values)
      this.doAction({
        path: apiPath,
        payload: {
          key: 'addActivityPart',
          apiParams: {
            ...fitterValues
          }
        }
      })
    }
  }

  _render() {
    const { activityPartLoading } = this.props
    const { cardTitle, columns, time } = this.state

    let onSubmit = this._addActivityPart.bind(this)
    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }

    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={activityPartLoading}>
          <WizForm key={time} className={'form-inline'} {...formProps} ref={(ref) => { this.wizFormRef = ref }} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { activityPart } = state;
  const addActivityPart = modelUtils.getModelEntity(activityPart, 'addActivityPart');
  const activityPartInfo = modelUtils.getModelEntity(activityPart, 'activityPartInfo');
  const load = modelUtils.getLoadingState(state, 'activityPart');
  return {
    addActivityPart,
    activityPartInfo,
    ...load
  }
}

export default connect(mapStateToProps)(ActivityPartDetail);

